import React, { useEffect, useRef, useState } from "react";
import { FaCrown } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import ScanModal from "./scanModal.jsx";
import { useNavigate, useParams } from "react-router-dom";
import { getIDScans } from "../../store/app/action.js";

function IDScans() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const id = useParams().id;
  const scans = useSelector((state) => state.app.idScans) || [];
  const idScanReviewCount = useSelector(
    (state) => state.app.dashboardActionCounts?.idScanReview ?? 0
  );
  const prevIdScanCountRef = useRef();
  const [showScan, setShowScan] = useState(null);
  useEffect(() => {
    dispatch(getIDScans());
  }, [dispatch]);
  useEffect(() => {
    if (prevIdScanCountRef.current === undefined) {
      prevIdScanCountRef.current = idScanReviewCount;
      return;
    }
    if (prevIdScanCountRef.current !== idScanReviewCount) {
      prevIdScanCountRef.current = idScanReviewCount;
      dispatch(getIDScans());
    }
  }, [idScanReviewCount, dispatch]);
  useEffect(() => {
    if(id){
      setTimeout(() => {
        setShowScan(id);
      }, 0)
    }else{
      setShowScan(null);
    }
  }, [id, setShowScan]);


  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
      {/* Page header */}
      <div className="sm:flex sm:justify-between sm:items-center mb-8">
        {/* Left: Title */}
        <div className="mb-4 sm:mb-0">
          <h1 className="text-2xl md:text-3xl text-slate-800 dark:text-slate-100 font-bold flex items-center gap-1">
            ID Scan Review <FaCrown />
          </h1>
        </div>

        {/* Right: Actions */}
      </div>
      <table className="table-auto w-full dark:text-slate-300 divide-y divide-slate-200 dark:divide-slate-700">
        {/* Table header */}
        <thead className="text-xs uppercase text-slate-500 dark:text-slate-400 bg-slate-50 dark:bg-slate-900/20 border-t border-slate-200 dark:border-slate-700">
          <tr>
            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
              <div className="font-semibold text-left">Customer</div>
            </th>
            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
              <div className="font-semibold text-left">Scan ID</div>
            </th>
            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
              <div className="font-semibold text-left">Acquisition Channel</div>
            </th>
            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
              <div className="font-semibold text-left">Received</div>
            </th>
          </tr>
        </thead>
        {/* Table body */}
        <tbody className="text-sm divide-y divide-slate-200 dark:divide-slate-700">
          {(scans || []).map((scan) => {
            return (
              <tr key={scan.scan_id} onClick={() => {
                navigate(`/id-scans/${scan.scan_id}`)
              }}>
                <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                  <div
                    className="font-semibold text-left">{`${scan.customer.first_name} ${scan.customer.last_name}`}</div>
                </td>
                <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                  <div className="text-left">{`${scan.scan_id}`}</div>
                </td>
                <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                  <div className="text-left">{`${scan.channel || "Marketplace"}`}</div>
                </td>
                <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                  <div className="text-left">{`${scan.api_result?.data?.date_submitted ? moment(scan.api_result?.data?.date_submitted) : "Unknown"}`}</div>
                </td>

              </tr>
            );
          })}
        </tbody>
      </table>
      <ScanModal id={showScan} close={() => {
        navigate("/id-scans")
      }} />
    </div>
  );
}

export default IDScans;
